import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PaymentContext } from '@/hooks/api/models';

/**
 * 0511. 支払タイプ一覧
 * [GET] /payment_contexts
 */
const paymentContexts = (): Promise<PaymentContext[]> => {
  return axios.get(`/api/payment_contexts`);
};

export const usePaymentContexts = () => {
  return useQuery({
    queryKey: ['payment_contexts'],
    queryFn: () => paymentContexts(),
  });
};
